"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMessageButton = exports.FormContainer = exports.Message = exports.TimeDisplay = exports.MessageContainer = exports.DateDisplay = exports.MessageItem = exports.MessageList = exports.Subject = exports.Container = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const core_1 = require("@material-ui/core");
const theme_1 = require("@monorepo/theme");
exports.Container = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #e5e5e5;
`;
exports.Subject = styled_components_1.default.h3 `
  font-family: PFDINText;
  font-weight: 400;
  font-size: 20px;
  text-transform: none;
  text-decoration: none;
  padding: 19px 30px;
  background-color: ${theme_1.colors.white};
`;
exports.MessageList = styled_components_1.default.ul `
  position: relative;
  padding: 35px;
`;
exports.MessageItem = styled_components_1.default.li `
  display: flex;
  flex: 1;
  flex-direction: column;
`;
exports.DateDisplay = styled_components_1.default.p `
  font-family: PFDINText;
  font-weight: 400;
  font-size: 14px;
  color: #707d8d;
  display: flex;
  flex: 1;
  justify-content: center;
`;
exports.MessageContainer = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: ${(props) => (props.sent ? 'row-reverse' : 'row')};
`;
exports.TimeDisplay = styled_components_1.default.span `
  font-family: PFDINText;
  font-weight: 400;
  font-size: 12px;
  color: #707d8d;
  align-self: flex-end;
`;
exports.Message = styled_components_1.default.p `
  padding: 14px;
  margin-top: 20px;
  background-color: ${(props) => (props.sent ? '#d4f1fd' : theme_1.colors.white)};
  ${({ sent }) => (sent ? `margin-left: 35%` : `margin-right: 35%`)};
  ${({ sent }) => sent
    ? `border-radius: 10px 0 10px 10px`
    : `border-radius: 0 10px 10px 10px`};
`;
exports.FormContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: 15px;
`;
exports.SendMessageButton = (0, styled_components_1.default)(core_1.Button) `
  padding: 10px;

  &.MuiButton-root {
    margin-top: 9px;
    height: 36px;
    border-radius: 0;
    border: 1px solid ${theme_1.colors.blue};
    background-color: ${theme_1.colors.blue};
    align-self: flex-end;
  }

  .MuiButton-label {
    color: ${theme_1.colors.white};
    font-size: 14px;
    font-weight: 400;
    font-family: PFDINText;
    text-transform: none;
  }
`;
